import React from "react";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import { setFile } from "../redux/creators/fileCreators";

/**
 * File upload input to change image
 *
 * @returns {Object}
 */
export default function ChangeImage() {
  const dispatch = useDispatch();
  const addFile = (file) => dispatch(setFile(file));
  const fileInput = React.createRef();
  return (
    <Label>
      Change
      <Input
        id="threekit-fileupload"
        type="file"
        name="fileupload"
        accept="image/png, image/jpg, image/jpeg"
        ref={fileInput}
        onChange={(e) => addFile(e.target.files[0])}
      />
    </Label>
  );
}

const Label = styled.label`
  font-weight: 300;
  font-size: 15px;
  line-height: 23px;
  text-decoration-line: underline;
  color: #000000;
  cursor: pointer;
`;
const Input = styled.input`
  display: none;
`;
